import React from "react";
import Nav from "../components/Nav";
import { useFormik } from "formik";
import Loader from "../components/Loading.svg";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PositionedSnackbar from "../components/snackbar";
import EmMain from "./EmployeeDashboard/EmMain";
import axios from "axios";
import { UseHrApp } from "../utils/context";

export default function SignInEmployee() {
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const formic = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (values) => {
      const errors = {};
      if (values.code === "") {
        errors.code = " Required";
        return errors;
      }
      /* if (values.email.trim() === "" && !values.password) {
            errors.email = "Required";
            errors.password = "Required";
            return errors;
          }*/
      if (values.email.trim() === "") {
        errors.email = "Required";
        return errors;
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid Email address";
        return errors;
      }
      if (!values.password) {
        errors.password = "Required";
        return errors;
      }

      return errors;
    },
    onSubmit: (values) => {
      formic.resetForm();
    },
  });

  const { text, settext, setshow, show, severity, setseverity } = UseHrApp();

  async function SignIn() {
    setloading(true);
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/api/employee/login",
        method: "POST",
        data: {
          email: formic.values.email,
          password: formic.values.password,
        },
      });
      if (res?.data?.status) {
        localStorage.setItem("EmployeeToken", res?.data?.token);
        navigate("/employee/mainDashboard/main");
      }
    } catch (error) {
      setshow(true);
      settext("Invalid Credentials");
      setseverity("error");
      setloading(false);
    }
  }

  return (
    <div className=" w-full h-screen ">
      <Nav />
      <div className=" w-full h-[90vh] flex flex-col justify-center items-center px-[2em]">
        <div className=" w-full min-h-[40%] flex flex-col justify-center gap-3 md:px-[11em] lg:px-[20em] xl:px-[27em]">
          <p className=" text-2xl font-[Archivo] font-medium">
            Enter your credentials
          </p>
          <form
            className=" flex flex-col gap-5"
            onSubmit={(e) => {
              e.preventDefault();
              SignIn();
            }}
          >
            <div>
              <Input
                label={"Email"}
                placeholder={"user@example.com"}
                name={"email"}
                type="email"
                onChange={formic.handleChange}
                value={formic.values.email}
                error={formic.errors.email}
              />
              {formic.errors.email && (
                <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                  *{formic.errors.email}
                </p>
              )}
            </div>
            <div>
              <Input
                label={"Password"}
                placeholder={"••••••••"}
                name={"password"}
                type="password"
                onChange={formic.handleChange}
                value={formic.values.password}
                error={formic.errors.password}
              />
              {formic.errors.password && (
                <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                  *{formic.errors.password}
                </p>
              )}
            </div>

            <button
              className=" w-max py-[.8em] px-[1em] bg-[#1E2029] rounded-[.8em]"
              type="submit"
            >
              <p className=" text-white">
                {loading ? (
                  <img src={Loader} className="h-[2rem]" key={loading} />
                ) : (
                  "Login"
                )}
              </p>
            </button>
          </form>

          <PositionedSnackbar
            value={show}
            setshow={setshow}
            text={text}
            severity={severity}
          />
        </div>
      </div>
    </div>
  );
}

const Input = ({ label, type, name, onChange, placeholder, value, error }) => {
  return (
    <div className="flex flex-col gap-3">
      <label className="text-[0.9rem] font-[400] text-black/50">{label}</label>
      <input
        formNoValidate={false}
        type={type}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        className={`focus:border-none  border-[2px] ${
          !error
            ? "focus:outline-[#4FFFB0] outline-black/25"
            : "focus:outline-[#EF0107] border-[#EF0107]"
        }  focus:outline-[2px]  px-4 py-2 rounded duration-700 text-black/80 bg-slate-50`}
      />
    </div>
  );
};
